import { curryN, compose, complement, prop } from 'ramda'
import { branch, renderComponent } from 'recompose'

const branch2 = curryN(2, branch)
const notLoaded = complement(prop('loaded'))

export default compose(
  branch2(notLoaded),
  renderComponent
)



// WEBPACK FOOTER //
// ./client/modules/util/withLoading.js